<template>
  <!-- <span style="color:yellow;">modalTheme {{ modalTheme }}</span> -->
  <div :class="modalTheme"><h6>Campaign Get My Dashboards</h6></div>
  <!-- <div :class="modalTheme"> -->
  <div :class="userStore.borderClass">
    <h6>Campaign Get My Dashboards</h6>

    <b-button :class="modalTheme" size="sm" @click="fetchMyDashboards">Get My Dashboards</b-button>
    <div v-if="loading">Loading...</div>
    <div v-if="error" style="color: red">{{ error }}</div>
    <pre v-if="dashboards">{{ dashboards }}</pre>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

import { getMyDashboards } from "@/api/campaignApi";

const modalTheme = computed(() => userStore.bModalTheme);

const dashboards = ref(null);
const loading = ref(false);
const error = ref("");

async function fetchMyDashboards() {
  // console.clear();

  // console.log("Fetching my dashboards...");

  loading.value = true;
  error.value = "";
  dashboards.value = null;
  try {
    const result = await getMyDashboards();
    dashboards.value = JSON.stringify(result, null, 2);
  } catch (e) {
    error.value = e?.message || "Failed to fetch dashboards";
  } finally {
    loading.value = false;
  }
}
</script>
